import { GA4Event} from "./GA4Event";

export function buildViewShippingBox(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("view_shipping_box", {
		items_in_box: attributes.items_in_box || '',
		interaction: attributes.interaction || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
